(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-mobile-header-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const menu = event.target.closest('.mg-mobile-actions .menu-icon');
    if (menu) {
      document.querySelector('.mobile-nav-wrapper')?.classList.add('active');
      menu.setAttribute('aria-expanded', 'true');
    }
    if (event.target.closest('.close-mobile-nav')) {
      document.querySelector('.mg-mobile-actions .menu-icon')?.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.mg-mobile-actions .menu-icon[aria-expanded="true"]');
    if (!menu) return;
    document.querySelector('.mobile-nav-wrapper')?.classList.remove('active');
    menu.setAttribute('aria-expanded', 'false');
    menu.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-product-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mg-product')) {
    class MotusProduct extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.data = JSON.parse(this.querySelector('[data-mg-data]').textContent);
        this.gallery = this.querySelector('.mg-pdp__gallery');
        this.slides = [...this.querySelectorAll('.mg-pdp__slide')];
        this.index = 0;
        this.querySelector('[data-mg-fallback]').hidden = true;
        const options = this.querySelector('[data-mg-options]');
        if (options) options.hidden = false;
        this.addEventListener('change', event => {
          if (event.target.matches('.mg-pdp__option input')) this.updateVariant(true);
        }, {signal});
        this.addEventListener('click', event => {
          const target = event.target.closest('button, [data-mg-zoom], [data-mg-full-image], [data-mg-reviews]');
          if (!target || !this.contains(target)) return;
          if (target.hasAttribute('data-mg-reviews')) {
            const widget = document.getElementById('judgeme_product_reviews');
            if (widget) {
              event.preventDefault();
              this.reviewWidget = widget;
              this.reviewHome = document.createComment('review-widget-location');
              widget.before(this.reviewHome);
              this.querySelector('[data-mg-reviews-slot]').append(widget);
              this.openDialog('reviews', target);
            }
          }
          if (target.hasAttribute('data-mg-prev')) this.goTo(this.index - 1);
          if (target.hasAttribute('data-mg-next')) this.goTo(this.index + 1);
          if (target.hasAttribute('data-mg-thumb')) this.goTo(Number(target.dataset.mgThumb));
          if (target.hasAttribute('data-mg-open')) this.openDialog(target.dataset.mgOpen, target);
          if (target.hasAttribute('data-mg-close')) target.closest('dialog').close();
          if (target.hasAttribute('data-mg-chart-back')) {
            target.closest('dialog').close();
            this.querySelector('[data-mg-chart]').scrollIntoView({block:'start'});
          }
          if (target.hasAttribute('data-mg-unit')) {
            const chart = target.closest('[data-mg-chart]');
            chart.querySelectorAll('[data-mg-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
            chart.querySelectorAll('td[data-cm]').forEach(cell => {cell.textContent = cell.dataset[target.dataset.mgUnit];});
            chart.querySelector('[data-mg-unit-caption]').textContent = target.textContent;
          }
          if (target.hasAttribute('data-mg-zoom')) {
            event.preventDefault();
            const image = this.querySelector('[data-mg-full-image]');
            const original = target.querySelector('img');
            image.classList.remove('is-enlarged');
            image.src = target.href;
            image.alt = original.alt;
            image.width = original.naturalWidth || 1600;
            image.height = original.naturalHeight || 2000;
            this.openDialog('zoom', target);
          }
          if (target.hasAttribute('data-mg-full-image')) target.classList.toggle('is-enlarged');
        }, {signal});
        this.gallery.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.gallery.scrollLeft / this.gallery.clientWidth)));
            this.updateCounter();
          });
        }, {passive:true, signal});
        this.gallery.addEventListener('keydown', event => {
          if (event.target !== this.gallery) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, {signal});
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, {signal});
          dialog.addEventListener('close', () => {
            if (dialog.dataset.mgDialog === 'recommend') {
              this.querySelector('[data-mg-recommend-form]').reset();
              this.querySelector('[data-mg-recommend-form]').hidden = false;
              this.querySelector('[data-mg-recommend-result]').hidden = true;
            }
            if (dialog.dataset.mgDialog === 'reviews' && this.reviewHome?.isConnected) {
              this.reviewHome.replaceWith(this.reviewWidget);
              this.reviewHome = null;
            }
            if (dialog.suppressReturnFocus) {dialog.suppressReturnFocus = false;return;}
            if (dialog.returnFocus?.isConnected) dialog.returnFocus.focus({preventScroll:true});
          }, {signal});
        });
        this.querySelector('[data-mg-recommend-form]').addEventListener('submit', event => {
          event.preventDefault();
          const form = event.target;
          if (!form.reportValidity()) return;
          form.reset();
          form.hidden = true;
          const result = this.querySelector('[data-mg-recommend-result]');
          result.hidden = false;
          result.focus();
        }, {signal});
        this.reviewModalObserver = new MutationObserver(() => {
          const drawer = this.querySelector('[data-mg-dialog="reviews"]');
          if (!drawer?.open) return;
          const modal = [...document.querySelectorAll('.jdgm-review-widget-modal')].find(item => getComputedStyle(item).display !== 'none');
          if (modal) {
            drawer.suppressReturnFocus = true;
            drawer.close();
          }
        });
        this.reviewModalObserver.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class']});
        this.updateVariant(false);
        const mediaIndex = this.slides.findIndex(slide => slide.dataset.mediaId === this.dataset.selectedMedia);
        if (mediaIndex >= 0) this.goTo(mediaIndex, false);
        else this.syncColorImage(false);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.reviewModalObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.initialized = false;
      }
      openDialog(name, trigger) {
        const dialog = this.querySelector(`[data-mg-dialog="${name}"]`);
        if (!dialog || dialog.open) return;
        dialog.returnFocus = trigger;
        dialog.showModal();
      }
      goTo(index, smooth = true) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.gallery.scrollTo({left:this.index * this.gallery.clientWidth, behavior:smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
        this.updateCounter();
      }
      updateCounter() {
        const count = this.querySelector('[data-mg-count]');
        if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.querySelectorAll('[data-mg-thumb]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.mgThumb) === this.index)));
      }
      syncColorImage(smooth) {
        const color = this.querySelector('[data-color-option] input:checked')?.value.toLowerCase();
        if (!color) return;
        const index = this.slides.findIndex(slide => {
          const words = (slide.querySelector('img')?.alt || '').toLowerCase().split(/[^a-z0-9]+/);
          return words.includes(color) || (color === 'grey' && words.includes('gray')) || (color === 'gray' && words.includes('grey'));
        });
        if (index >= 0) this.goTo(index, smooth);
      }
      updateVariant(updateUrl) {
        const fields = [...this.querySelectorAll('.mg-pdp__option')];
        const options = fields.map(field => field.querySelector('input:checked')?.value);
        const select = this.querySelector('[data-mg-variant]');
        const variant = fields.length ? this.data.variants.find(item => item.options.every((value, index) => value === options[index])) : this.data.variants.find(item => String(item.id) === select.value);
        fields.forEach((field,index) => {
          field.querySelector('[data-mg-option-value]').textContent = options[index] ? ` — ${options[index]}` : '';
          field.querySelectorAll('input').forEach(input => {
            const possible = this.data.variants.some(item => item.available && item.options.every((value,i) => value === (i === index ? input.value : options[i])));
            input.nextElementSibling.dataset.sold = String(!possible);
          });
        });
        const add = this.querySelector('[data-mg-add]');
        add.disabled = !variant?.available;
        add.textContent = !variant ? this.data.unavailable : variant.available ? this.data.add : this.data.sold;
        this.querySelector('[data-mg-availability]').textContent = variant?.available ? '' : add.textContent;
        if (!variant) {select.value = '';return;}
        select.value = String(variant.id);
        this.querySelector('[data-mg-price]').textContent = variant.price;
        const compare = this.querySelector('[data-mg-compare]');
        compare.hidden = !variant.compare;
        compare.textContent = variant.compare || '';
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
          const imageIndex = this.slides.findIndex(slide => slide.dataset.mediaId === String(variant.media));
          if (imageIndex >= 0) this.goTo(imageIndex);
          else this.syncColorImage(true);
        }
      }
    }
    customElements.define('mg-product', MotusProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
